module.exports = {
  langKey: 'sk',
  'selectLanguage': 'Slovensky',
  'sk': 'Slovensky',
  'en': 'English'
};
